import React from "react"
import { Notification } from "../Notification"

export const NotificationDropdown = ({
  meta_id,
  closeDropdown,
  notifications,
  onNotificationClick,
  onClear,
}) => {
  const notificationUI =
    notifications && notifications.length
      ? notifications.map((el, index) => {
          return (
            <Notification
              key={index}
              notification={el}
              onClick={() => onNotificationClick(el)}
            />
          )
        })
      : []

  return (
    <div
      className="dropdown_content notification_dropdown"
      meta-id={meta_id}
      onClick={closeDropdown}
    >
      {notifications && notifications.length ? (
        <React.Fragment>
          <p className="clearNotifications" onClick={() => onClear()}>
            Clear All
          </p>
          {notificationUI}
        </React.Fragment>
      ) : null}
      {notifications && !notifications.length ? (
        <p className="noNotifications">
          We'll let you know when we get news for you.
        </p>
      ) : null}
    </div>
  )
}
